import { Col, Descriptions, Form, Modal, Row, Select } from 'antd';
import styled from 'styled-components';
import moment from 'moment';

import { AssetType, Expense } from '../../modules/expenses';
import { useEffect, useState } from 'react';
import {
  corporateNumberFormatter,
  phoneFormatter,
  priceToString,
} from '../../util/utils';
import TextArea from 'antd/lib/input/TextArea';
import { getExpenseMyCommon } from '../../api/constlink';

const StyledDiv = styled.div``;

const { Option } = Select;

interface MyExpenseSubmitModalProps {
  expense: Expense;
  enterpriseId: string;
  onCreate: (value: any) => void;
  onCancel: () => void;
}

function MyExpenseSubmitModal({
  expense,
  enterpriseId,
  onCreate,
  onCancel,
}: MyExpenseSubmitModalProps) {
  const [form] = Form.useForm();
  const [mount, setMount] = useState(true);
  const [projectList, setProjectList] = useState<any[]>();
  const [gongjongList, setGongjongList] = useState<any[]>();
  const [categoryList, setCategoryList] = useState<any[]>();

  const [expenseCommon, setExpenseCommon] = useState<any>();

  useEffect(() => {
    (async () => {
      const _expenseCommon = await getExpenseMyCommon(enterpriseId);
      setExpenseCommon({
        ..._expenseCommon,
      });
    })();
  }, [enterpriseId]);

  useEffect(() => {
    if (!mount) return;
    if (expenseCommon === undefined) return;
    let children: any = [];
    for (const project of expenseCommon.projectList.sort((a: any, b: any) =>
      b.startDate.localeCompare(a.startDate),
    )) {
      children.push(
        <Option key={project.id} value={project.id}>
          {project.name}
        </Option>,
      );
    }
    setProjectList(children);
    children = [];
    for (const category of expenseCommon.categoryList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={category.id} value={category.name}>
          {category.name}
        </Option>,
      );
    }
    setCategoryList(children);

    children = [];
    for (const gongjong of expenseCommon.gongjongList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={gongjong.id} value={gongjong.name}>
          {gongjong.name}
        </Option>,
      );
    }
    setGongjongList(children);

    return () => setMount(false);
  }, [expenseCommon, mount]);

  // console.log('expense', expense);
  // console.log('expenseCommon', expenseCommon);

  return (
    <StyledDiv>
      <Modal
        open={expense !== undefined}
        title="지출정보"
        okText="확인"
        cancelText="취소"
        onCancel={onCancel}
        width={800}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              onCreate(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Descriptions
          bordered
          column={2}
          size="small"
          style={{ marginBottom: '20px' }}
        >
          <Descriptions.Item label="업체명">
            {expense.companyName}
          </Descriptions.Item>
          <Descriptions.Item label="부가세">
            {priceToString(expense.vat)}
          </Descriptions.Item>
          <Descriptions.Item label="합계 금액(원)">
            {priceToString(expense.price)}
          </Descriptions.Item>
          {!!expense.financialAssetInfo &&
            expense.financialAssetInfo.assetType === AssetType.CARD && (
              <Descriptions.Item label="카드정보">
                {expense.financialAssetInfo.name} /{' '}
                {expense.financialAssetInfo.number}
              </Descriptions.Item>
            )}
          <Descriptions.Item label="주소">
            {expense.companyAddress}
          </Descriptions.Item>
          {!!expense.assetData && (
            <>
              <Descriptions.Item label="전화번호">
                {phoneFormatter(expense.assetData.resMemberStoreTelNo, 1)}
              </Descriptions.Item>
              <Descriptions.Item label="사업자등록번호">
                {corporateNumberFormatter(
                  expense.financialAssetInfo.assetType === AssetType.CARD
                    ? expense.assetData.resMemberStoreCorpNo
                    : expense.assetData.resSupplierRegNumber,
                )}
              </Descriptions.Item>
            </>
          )}
          <Descriptions.Item label="사용일시">
            {expense.financialAssetInfo === null ||
            expense.financialAssetInfo.assetType === AssetType.CARD
              ? moment(expense.usedDateTime).format('YYYY-MM-DD HH:mm:ss')
              : moment(expense.usedDateTime).format('YYYY-MM-DD')}
          </Descriptions.Item>
        </Descriptions>

        <Form form={form} layout="vertical" initialValues={{}}>
          <Row>
            <Col span={24}>
              <Form.Item
                name={['project', 'id']}
                label="프로젝트"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select style={{ width: '100%' }}>{projectList}</Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item name="gongjong" label="공사종류">
                <Select style={{ width: '100%' }} allowClear>
                  {gongjongList}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="category"
                label="용도"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select style={{ width: '100%' }}>{categoryList}</Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item name="description" label="설명">
                <TextArea rows={4} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </StyledDiv>
  );
}

export default MyExpenseSubmitModal;
